import React, { useEffect, useMemo, useState } from "react"
import { IconButton, InputAdornment, InputBase, TextField, Typography, Popover } from "@material-ui/core"
import { DetailWrapperOqt } from "../";
import { Error } from "@material-ui/icons";
import { TextOqt } from "./TextOqt";

export const TextPropertyName = React.memo((props) => {
  return <TextOqt {...props} regExpAccept="^([abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789])*$" />
})